function hexToStruct(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

function hexaToStruct(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
    hex.trim()
  );
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
        a: (parseInt(result[4], 16).toFixed(2) / 255.0).toFixed(2),
      }
    : null;
}

function rgbToStruct(rgb) {
  const re = /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
  const match = re.exec(rgb);
  if (!match) {
    return null;
  }
  const r = match[1];
  const g = match[2];
  const b = match[3];
  if (r < 0 || r > 255) {
    return null;
  }
  if (g < 0 || g > 255) {
    return null;
  }
  if (b < 0 || b > 255) {
    return null;
  }

  return { r, g, b };
}

function isRgb(c) {
  const re = /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
  const match = re.exec(c);
  return match;
}

function isRgba(c) {
  const re = /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,(.*)\)$/;
  const match = re.exec(c);
  return match;
}

function rgbaToStruct(rgb) {
  const re = /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,(.*)\)$/;
  const match = re.exec(rgb);
  if (!match) {
    return null;
  }
  const r = match[1];
  const g = match[2];
  const b = match[3];
  const a = match[4];

  if (r < 0 || r > 255) {
    return null;
  }
  if (g < 0 || g > 255) {
    return null;
  }
  if (b < 0 || b > 255) {
    return null;
  }

  if (a < 0 || a > 1) {
    return null;
  }

  return { r, g, b, a };
}

function toRgbaStruct(color) {
  if (hexaToStruct(color)) {
    return hexaToStruct(color);
  } 
  if (rgbaToStruct(color)) {
    console.log("toRgbaStruct returning ", rgbaToStruct(color));
    return rgbaToStruct(color);
  }
  console.log("toRgbaStruct returning 0, color ", color);
  return null;
} 

function toRgbStruct(color) {
  if (hexToStruct(color)) {
    return hexToStruct(color);
  } 
  if (rgbToStruct(color)) {
    return rgbToStruct(color);
  }
  return null;
} 

function toRgbString(color) {
 return `rgb(${color.r},${color.g},${color.b})`;
}

/*
function getOpacity(color) { 
  ("a" in color)? color.a : 1;
}
*/

const getOpacity = color => ("a" in color)? color.a : 1;


function isDarkColor(color) {
  if(color== null) {
    return false;
  }
  
  console.log("isDarkColor", color);
  let c = {r:255,g:255,b:255};
  if (typeof color !== "object") {
    if(isRgba(color)) {
      const c4 = toRgbaStruct(color);
      c.r=c.r*(1-c4.a) + c4.r*c4.a;
      c.g=c.g*(1-c4.a) + c4.g*c4.a;
      c.b=c.b*(1-c4.a) + c4.b*c4.a;
    } else if(isRgb(color)) {
      c = toRgbStruct(color);
    }
  } else if("a" in color) {
    const c4 = color;
    c.r=c.r*(1-c4.a) + c4.r*c4.a;
    c.g=c.g*(1-c4.a) + c4.g*c4.a;
    c.b=c.b*(1-c4.a) + c4.b*c4.a;
  } else {
    c = color;
  }

  if(!c) {
    return false;
  }
  const result= (parseInt(c.r) + parseInt(c.g) + parseInt(c.b)) < 128*3;
  console.log(c);
  console.log(parseInt(c.r) + parseInt(c.g) + parseInt(c.b));
  console.log("isDarkColor ", result)
  return (parseInt(c.r) + parseInt(c.g) + parseInt(c.b)) < 128*3;
}

export {toRgbStruct, toRgbaStruct, hexToStruct, hexaToStruct,rgbToStruct, rgbaToStruct, toRgbString, getOpacity, isDarkColor}
